import { render } from "./priceFilter.vue?vue&type=template&id=1848d61f&scoped=true"
import script from "./priceFilter.vue?vue&type=script&lang=js"
export * from "./priceFilter.vue?vue&type=script&lang=js"

import "./priceFilter.vue?vue&type=style&index=0&id=1848d61f&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1848d61f"]])

export default __exports__